import { render, staticRenderFns } from "./oview.vue?vue&type=template&id=f4ac41d0"
import script from "./oview.vue?vue&type=script&lang=js"
export * from "./oview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports